"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonFooterDisp = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
const _excluded = ["returnBtn"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const FooterRoot = (0, _styles.styled)('footer')({
  width: '100%',
  textAlign: 'right'
});

/**
 * 監査回答登録結果画面フッタのボタン
 */
const ButtonFooterDisp = props => {
  const {
      returnBtn
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(FooterRoot, other, typeof returnBtn === 'function' ? returnBtn() : null);
};
exports.ButtonFooterDisp = ButtonFooterDisp;
var _default = exports.default = ButtonFooterDisp;